module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.46888f27.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Thin.woff2
// module id = 549
// module chunks = 0